import { OptionCustomProps } from '@/components/Purchases/components/SelectOkpd2/components/Option.js';
import { useCallback } from 'react';
import React from 'react';
import { MultiValueGenericProps } from 'react-select';
import { GroupBase } from 'react-select';
import { FormatOptionLabelMeta } from 'react-select';

export interface MultiValueLabelCustomProps<Option> {
  selectedItem: Option | null;
  onMultiValueItemSelect: (value: Option) => void;
}

export const MultiValueLabel = <
  Option,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: MultiValueGenericProps<Option, IsMulti, Group>,
) => {
  const {
    innerProps,
    selectProps: { formatOptionLabel },
    data: value,
  } = props;

  const { selectedItem, onMultiValueItemSelect } = (
    props.selectProps as unknown as {
      customProps: MultiValueLabelCustomProps<Option>;
    }
  ).customProps;

  const hasSelectedItem = Boolean(selectedItem);

  const handleMouseDown = useCallback(
    (event: any) => {
      if (!hasSelectedItem || selectedItem !== value) {
        /*
         * Если не отмечен выбранный элемент или отмечен, но не совпадает с тем что был выбран ранее, то
         * отмечаем выбранный элемент
         */
        onMultiValueItemSelect?.(value);
      }
      if (hasSelectedItem && selectedItem !== value) {
        /*
         * Если отмечается новый элемент, то отменяем действие по-умолчанию, чтобы
         * предотвратить выпадающего списка если он был открыт
         */
        event.preventDefault();
        event.stopPropagation();
      }
    },
    [hasSelectedItem, onMultiValueItemSelect, selectedItem, value],
  );

  return (
    <div
      {...innerProps}
      onMouseDown={handleMouseDown}
      data-multivalue-label="true"
    >
      {formatOptionLabel
        ? formatOptionLabel(value, {
            context: 'value',
          } as FormatOptionLabelMeta<Option>)
        : value.name}
    </div>
  );
};
